var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurchases(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.557 5.094C15.672 5.344 16 6 16 6l-.768 4.606c-.286 1.717-.429 2.575-.903 3.19-.267.346-.604.631-.988.837-.685.367-1.555.367-3.295.367H5.954c-1.74 0-2.61 0-3.295-.367a3.1 3.1 0 0 1-.988-.837c-.474-.615-.617-1.473-.903-3.19L0 6s.328-.657 4.443-.906c.155-.76.336-1.467.551-2.093.28-.817.636-1.549 1.11-2.086C6.59.362 7.22 0 8 0s1.409.362 1.896.915c.473.537.829 1.268 1.11 2.086.215.626.395 1.333.55 2.093M5.534 6.343Q5.403 7.139 5.292 8h-1.31q.1-.811.224-1.588c-1.338.093-2.19.229-2.72.353l-.039.01.603 3.617c.147.882.244 1.46.358 1.897.108.418.205.6.293.713.154.2.35.366.572.485.127.068.322.134.752.172.45.04 1.036.041 1.93.041h4.09c.894 0 1.48-.001 1.93-.04.43-.039.625-.105.752-.173.223-.12.418-.284.572-.485.088-.114.185-.295.293-.713.114-.438.211-1.015.358-1.896l.603-3.618-.038-.01c-.53-.124-1.383-.26-2.72-.353q.122.777.224 1.588h-1.31a45 45 0 0 0-.243-1.657A66 66 0 0 0 8 6.3c-.933 0-1.75.016-2.466.043m.25-1.31Q6.775 5.001 8 5q1.227 0 2.215.033a15 15 0 0 0-.439-1.61q-.385-1.116-.855-1.648C8.623 1.437 8.326 1.3 8 1.3s-.623.137-.921.475c-.312.354-.6.904-.855 1.648-.165.481-.31 1.022-.44 1.61",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchases);
export default __webpack_public_path__ + "static/media/purchases.66d3e925aaa2d5c8efeea0895d3be58b.svg";
export { ForwardRef as ReactComponent };